import { useUser } from "@/zustand/store";
import { LogOut } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const TopBar = () => {
  const navigate = useNavigate();
  const [optionIsOpen, setOptionIsOpen] = useState(false);
  const { user } = useUser((state) => state);

  return (
    <nav className="bg-primary-500 text-primary-100 flex items-center justify-between rounded-lg px-4 py-4">
      <div className="space-y-1">
        <p className="text-lg leading-3">Welcome</p>
        <p className="text-3xl leading-6 font-bold capitalize">{`${user?.firstName} ${user?.lastName}`}</p>
      </div>
      <div className="relative">
        <div
          onClick={() => setOptionIsOpen(!optionIsOpen)}
          className="bg-primary-500 flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full"
        >
          <span className="bg-primary-50 flex h-8 w-8 items-center justify-center rounded-full text-white">
            {user?.firstName.substring(0, 1)}
          </span>
        </div>
        {optionIsOpen && (
          <div className="options-menu absolute top-[calc(100%+20px)] right-0 z-[999] min-w-50 rounded-xl bg-white p-4 shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
            <div className="flex items-center gap-2">
              <span className="bg-primary-500 flex h-8 w-8 items-center justify-center rounded-full text-white">
                {user?.firstName.substring(0, 1)}
              </span>
              <p className="text-primary-500 text-lg font-medium">
                {user?.firstName} {user?.lastName}
              </p>
            </div>
            <p className="text-primary-500/80 text-sm">{user?.email}</p>

            <div className="bg-primary-bg my-2 h-[1px]" />

            <div
              onClick={() => {
                useUser.setState({ user: null });
                sessionStorage.removeItem("token");
                toast.success("Logout successful");
                navigate("/login");
              }}
              className="text-primary-500 hover:bg-primary-500/10 -mx-4 flex items-center gap-2 px-4 py-2 text-base font-medium"
            >
              <span>Logout</span> <LogOut className="size-4" />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopBar;
